<template>
  <div id="app">
    <section id="produk" class="team page-margin">
      <div class="team-decor">
        <div class="team-circle1">
          <img :src="'../assets/images/produk-page2.png'" alt="" />
        </div>
        <div class="team-circle2">
          <img :src="'../assets/images/efunding-icon.png'" width="80px" alt="" />
        </div>
      </div>
      <div class="container">
        <div class="row ">
          <div class="col-sm-12">
            <h2 class="title">Produk - Produk <span>Pilihan</span></h2>
          </div>
          <div class="col-sm-12">
            <div>
              <carousel v-if="loaded" :className="'team-carousel'" :loop="true" :margin="30" :items="3" :nav="false" :dots="true" :dotsEach="true" :autoplay="false" :responsive="{
                0: { items: 1, margin: 5 },
                600: { items: 1, margin: 5 },
                768: { items: 2 },
                992: { items: 3 },
                1000: { items: 3 }
              }">
                <div class="team-item" v-for="(item, index) in items.slice(0, 5)" :key="index">
                  <div class="team-block">
                    <div class="team-box">
                      <div class="image-container">
                        <img class="team-image" :src="getImageUrl(item)" :class="{
                          'small-image':
                            !item.mitra ||
                            !item.mitra.mitra_profile ||
                            !item.mitra.mitra_profile.logo_mitra
                        }" alt="" />
                      </div>
                      <div class="team-text">
                        <h3>{{ item.nama_produk }}</h3>
                        <h6>{{ item.fitur_utama }}</h6>
                        <h6>{{ item.min_initial_deposit | currency }}</h6>
                      </div>
                      <div class="overlay">
                        <ul class="team-social">
                          <router-link :to="{
                            name: 'DetailProduk',
                            params: { id: item.id }
                          }">Detail Produk</router-link>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </carousel>

              <div class="text-center mt-2">
                <b-button class="btn btn-custom theme-color" to="list-produk">Lihat Semua Produk</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Product from "../api/produk.js";

export default {
  name: "produk",
  data() {
    return {
      loaded: false,
      items: [],
      productImage: ""
    };
  },
  created() { },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      Product.index().then(res => {
        this.items = res.data.data.data;
        this.productImage = process.env.API_URL;
        this.loaded = true;
      });
    },
    getImageUrl(item) {
      if (
        item.mitra &&
        item.mitra.mitra_profile &&
        item.mitra.mitra_profile.logo_mitra
      ) {
        return this.productImage + item.mitra.mitra_profile.logo_mitra;
      } else {
        return require("../assets/images/Simpananproduk.png");
      }
    }
  }
};
</script>

<style scoped>
.small {
  max-width: 600px;
  margin: 150px auto;
}

.team-social a {
  border: none;
  background: #f6bc3b;
  border-radius: 10px;
  padding: 7px;
  color: white;
}

.image-container {
  text-align: center;
}

.team-image {
  width: 100px;
  height: auto;
  object-fit: cover;
  border-radius: 0;
  margin: auto;
}

.small-image {
  max-width: 100px;
  max-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/produk.vue